<form [formGroup]="restantPgaVoorgaandeJaren">
    <div *ngIf="pgaRestantPgaVoorgaandeJaren.length > 0">
        <div formArrayName="pgaRestantPgaVoorgaandeJaren">
            <div *ngFor="let item of pgaRestantPgaVoorgaandeJaren.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                                                placeholder="Restant PGA voorgaande jaren"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijRestantPgaVoorgaandeJaren(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     icon="trash"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="pgaRestantPgaVoorgaandeJaren.length === 0">
    <snelstart-ui-button (click)="addRijRestantPgaVoorgaandeJaren()" class="snelstart-ui-button" icon="plus"
                         type="link">Restant voorgaande jaren
    </snelstart-ui-button>
</div>
